import { Hero } from "../components/Hero";
import { About } from "../components/About";
import { Services } from "../components/Services";
import { Projects } from "../components/Projects";
import { Contact } from "../components/Contact";
import { Navigation } from "../components/Navigation";
import { Footer } from "../components/Footer";

export function HomePage() {
  return (
    <>
      <Navigation />
      <main>
        <Hero />
        <About />
        <Services />
        <Projects isFullPage={false} />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
